// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jzq1YNKP7XsWj4AwXAc7{align-items:center;gap:8px;display:flex}.Jzq1YNKP7XsWj4AwXAc7 .FZiBhm2dVAJJmjtyQGFR{border:1px solid var(--black-20);background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:100%;justify-content:center;align-items:center;width:48px;height:48px;display:flex}.Jzq1YNKP7XsWj4AwXAc7 .FZiBhm2dVAJJmjtyQGFR.nbIAT9zVFDU6txhRAYuy{border-radius:6px}.Jzq1YNKP7XsWj4AwXAc7 .PgvjPHwyLJspkzz8lF1F{max-width:300px;margin-top:4px;display:block}.seNx1X9_69s0vOygmb0D{flex-direction:column;padding:0 0 2px 4px;display:flex}.LwyVA2Oijm4eoY0dPWHH{height:-webkit-max-content;height:max-content}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoWrap": `Jzq1YNKP7XsWj4AwXAc7`,
	"logo": `FZiBhm2dVAJJmjtyQGFR`,
	"square": `nbIAT9zVFDU6txhRAYuy`,
	"logoSubtitle": `PgvjPHwyLJspkzz8lF1F`,
	"labelWrap": `seNx1X9_69s0vOygmb0D`,
	"uploadButton": `LwyVA2Oijm4eoY0dPWHH`
};
export default ___CSS_LOADER_EXPORT___;
